import moment from 'moment'
import api from '../../../services/service'
import apiCus from '../../../services/service_customer'
import apiVen from '../../../services/service_vendor'
export default {
  data () {
    return {
      nowDate: moment(new Date()),
      header: {
        'Access-Token': this.$store.state.token
      },
      data_detail: [],
      data_list_cus: [],
      data_vlist: []
    }
  },
  methods: {
    handleChange (value) {
      console.log(`selected ${value}`)
    },
    SelectChange (value) {
      console.log(`selected ${value}`)
      this.data_detail.def_cust_code = value
    },
    SelectChangeVen (value) {
      console.log(`selected ${value}`)
      this.data_detail.def_vendor_code = value
    },
    handleBlur (val) {
      console.log('blur')
      console.log(val)
    },
    handleFocus () {
      console.log('focus')
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getCusAll () {
      this.$store.commit('Loading')
      let body = {
        'keyword': '',
        'limit': 1000,
        'status': 1
      }
      apiCus.listAll(this.REST_URL,
        this.header,
        body,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.data_list_cus = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    getVendor () {
      this.$store.commit('Loading')
      let body = {
        'keyword': '',
        'limit': 1000,
        'status': 1
      }
      apiVen.listAll(this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.data_vlist = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลเจ้าหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getConfig () {
      this.$store.commit('Loading')
      api.configDetail(this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            this.data_detail = result.data[0]
          } else {
            this.$notification['success']({
              message: 'ดึงข้อมูลสาขา',
              description:
                      result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    editConfig () {
      this.$store.commit('Loading')
      this.data_detail.id = parseInt(this.data_detail.id)
      this.data_detail.company_id = parseInt(this.data_detail.company_id)
      this.data_detail.tax_rate = parseInt(this.data_detail.tax_rate)
      api.confighUpdate(this.REST_URL,
        this.header,
        this.data_detail,
        result => {
          if (result.response === 'success') {
            this.getConfig()
            this.$notification['success']({
              message: 'อัพเดทข้อมูลสาขาสำเร็จ'
            })
          } else {
            this.$notification['success']({
              message: 'อัพเดทข้อมูลสาขา',
              description:
                      result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.getConfig()
    this.getVendor()
    this.getCusAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/settings/branch.js